import React from 'react';
import { MapContainer, TileLayer, Marker, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './MiniLocationMap.css';

const makeIcon = (color, label) => L.divIcon({
    className: 'mlm-pin',
    html: `<div class="mlm-pin-inner" style="background:${color}"><span>${label}</span></div>`,
    iconSize: [24, 24],
    iconAnchor: [12, 24],
});

// Kart içinde küçük harita — drawer scroll'lu container'da mount olur; boyut ilk render'da
// yanlis olabilir → invalidateSize + setView ile pini ortala.
function Recenter({ position, zoom }) {
    const map = useMap();
    React.useEffect(() => {
        const fit = () => { map.invalidateSize(); map.setView(position, zoom); };
        const t0 = setTimeout(fit, 0);
        const t1 = setTimeout(fit, 250);
        const t2 = setTimeout(fit, 600);
        return () => { clearTimeout(t0); clearTimeout(t1); clearTimeout(t2); };
    }, [map, position, zoom]);
    return null;
}

// Tek koordinati kart icinde pinli mini harita olarak gosterir (etkilesimsiz).
const MiniLocationMap = ({ position, color = '#f59e0b', label = '', zoom = 15 }) => {
    if (!position || position[0] == null || position[1] == null) return null;
    return (
        <div className="mlm">
            <MapContainer
                center={position}
                zoom={zoom}
                className="mlm-map"
                zoomControl={false}
                scrollWheelZoom={false}
                dragging={false}
                doubleClickZoom={false}
                touchZoom={false}
                keyboard={false}
                attributionControl={false}
            >
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <Marker position={position} icon={makeIcon(color, label)} />
                <Recenter position={position} zoom={zoom} />
            </MapContainer>
        </div>
    );
};

export default MiniLocationMap;
